import moment from "moment";
import ContractsApi from "./index";
import SettingsApi from "../Settings";

export const getContractsByOwnerId = async () => {
  const response = await ContractsApi.getContractsList({ page: 1, limit: 1000 });
  const payload = response?.data?.data ?? {};
  const contracts = Array.isArray(payload?.data) ? payload.data : [];

  return contracts.reduce((map, contract) => {
    if (contract?.owner_id) {
      map[contract.owner_id] = contract;
    }
    return map;
  }, {});
};

const getMetuaaCompanyName = async () => {
  try {
    const response = await SettingsApi.getMetuaaProfile();
    const record =
      response?.data?.data?.data || response?.data?.data || response?.data || null;
    return record?.company_name || "";
  } catch (error) {
    return "";
  }
};

export const createProgramServiceAgreement = async (
  ownerId,
  counterpartyEmail = "",
  driverName = ""
) => {
  const response = await ContractsApi.createContract({
    title: "Service Agreement",
    type: "SERVICE",
    status: "draft",
    counterparty_name: driverName,
    counterparty_email: counterpartyEmail,
    owner_id: ownerId,
    department: "Legal",
    value_amount: null,
    value_currency: "XAF",
    start_date: moment().format("YYYY-MM-DD"),
    end_date: moment().add(1, "year").format("YYYY-MM-DD"),
    auto_renew: false,
    renewal_notice_day: 30,
    governing_law: "Cameroon law",
    risk_score: 2,
    metadata: {},
  });

  return response?.data?.data || null;
};
